import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './Home';
import AboutMe from './AboutMe';
import NavBar from './NavBar';
import Disenoz from './Disenoz';
import ContactMe from './ContactMe';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import PageNotFound from "./NotFoundPage";
import Profolio from './Profolio';
import Commisions from './Commisions';
import {
  TransitionGroup,
  CSSTransition
} from "react-transition-group";
import "../style/App.css";




function App() {
  return (
    <Router>
      <ScrollToTop />
      <NavBar />
      <Route render={({location}) => (
        <TransitionGroup>
          <CSSTransition
            key={location.key}
            timeout={1000}
            classNames="fade"
          >
            <Switch >
              <Route exact path="/" >
                <Home />
              </Route>
              <Route path="/Profolio" >
                <Profolio />
              </Route>
              <Route path="/Disenoz" >
                <Disenoz />
              </Route>
              <Route path="/AboutMe" >
                <AboutMe />
              </Route>
              <Route path="/ContactMe" >
                <ContactMe />
              </Route>
              <Route path="/Commisions">
                <Commisions />
              </Route>
              <Route>
                <PageNotFound />
              </Route>
            </Switch>
          </CSSTransition>
        </TransitionGroup>
      )} />
      <Footer />
    </Router>
  );
}

export default App;
